import React, { FC, useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import "./FacialErrorToast.css";
import closeCircleIcon from "../../areas/cashless/nominalCashless/close-circle-line.svg";

interface FacialErrorToastProps {
  isOpen: boolean;
  onRetry: () => void;
  onBack: () => void;
  onClose?: () => void;
  message?: string;
}

export const FacialErrorToast: FC<FacialErrorToastProps> = ({
  isOpen,
  onRetry,
  onBack,
  onClose,
  message = "Ops, o rosto não foi encontrado",
}) => {
  const nodeRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (onClose) {
          onClose();
        }
      }, 5000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [isOpen, onClose]);

  return (
    <CSSTransition
      mountOnEnter
      unmountOnExit
      in={isOpen}
      timeout={500}
      classNames="facial-error-modal"
      nodeRef={nodeRef}
    >
      <div className="FacialErrorToast" ref={nodeRef}>
        <div className="message-FacialErrorToast">
          <div className="icon-FacialErrorToast">
            <img src={closeCircleIcon} alt="Erro" />
          </div>
          <div className="text-FacialErrorToast">
            <span className="title">{message}</span>
          </div>
          <div className="buttons-FacialErrorToast">
            <button className="retry-button" onClick={onRetry}>
              Tentar novamente
            </button>
            <button className="back-button" onClick={onBack}>
              Voltar
            </button>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};
